export class MultimediaManagerDialogItem {
    private editable: boolean;
    private fatherFolderInternalId: string;
    private internalId: string;
    private name: string;
    private size: string;
    private type: MultimediaManagerDialogItemTypes;
    private url: string;
    private urlThumbnail: string;
    private zoomLevel: number;

    constructor(editable?: boolean, fatherFolderInternalId?: string, internalId?: string, name?: string, size?: string, type?: MultimediaManagerDialogItemTypes, url?: string, urlThumbnail?: string, zoomLevel?: number) {
        this.editable = editable;
        this.fatherFolderInternalId = fatherFolderInternalId;
        this.internalId = internalId;
        this.name = name;
        this.size = size;
        this.type = type;
        this.url = url;
        this.urlThumbnail = urlThumbnail;
        this.zoomLevel = zoomLevel;
    }

    public get Editable() {
        return this.editable;
    }
    public get FatherFolderInternalId() {
        return this.fatherFolderInternalId;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get Name() {
        return this.name;
    }
    public get Size() {
        return this.size;
    }
    public get Type() {
        return this.type;
    }
    public get Url() {
        return this.url;
    }
    public get UrlThumbnail() {
        return this.urlThumbnail;
    }
    public get ZoomLevel() {
        return this.zoomLevel;
    }

    public set Editable(editable) {
        this.editable = editable;
    }
    public set FatherFolderInternalId(fatherFolderInternalId) {
        this.fatherFolderInternalId = fatherFolderInternalId;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set Name(name) {
        this.name = name;
    }
    public set Size(size) {
        this.size = size;
    }
    public set Type(type) {
        this.type = type;
    }
    public set Url(url) {
        this.url = url;
    }
    public set UrlThumbnail(urlThumbnail) {
        this.urlThumbnail = urlThumbnail;
    }
    public set ZoomLevel(zoomLevel) {
        this.zoomLevel = zoomLevel;
    }
}

export enum MultimediaManagerDialogItemTypes {
    FOLDER = 'FOLDER',
    IMAGE_FILE = 'IMAGE',
    IMAGE_URL = 'IMAGE_URL',
    VIDEO_FILE = 'VIDEO',
    VIDEO_URL = 'VIDEOURL',
    VIDEO_YOUTUBE = 'YOUTUBE',
    WEB = 'WEB',
    WEB_SCRIPT = 'WEBSCRIPT',
    WEB_URL = 'WEBURL'
}
